export default ['daily', 'weekly', 'monthly'];
